import shortid from "shortid";
import { SET_FACTOR, SET_FACTORS, SET_FACTOR_PATTERN } from "../../constants/factorConstants";
import { RESET_FACTOR } from "constants/formConstants";

export const invoiceInitialValues = {
  header: "",
  logo: "",
  background: "",
  backroundColor: "",
  sign: "",
  showCustomerSign: "",
  showSellerSign: true,
  paddingTop: 32,
  paddingRight: 32,
  paddingBottom: 32,
  paddingLeft: 32,
  borderSize: 0,
  invoiceHeaderSize: 14,
  invoiceBodySize: 12,
  invoiceHeaderColor: "",
  invoiceBodyColor: "",
  description: "",
  showAccountingCode: true,
  showReferral: true,
  showDate: true,
  showTime: false,
  showDueDate: true,
  showReference: false,
  showPaymentPrice: false,
  showBalancePrice: false,
  showProductcode: true,
  showProductDescription: false,
  showDiscount: true,
  showTax: true,
  showChortkeLogo: true,
  businessName: "شخص/شرکت",
  address: "آدرس",
  telephone: "تلفن",
  cutomerBusinessName: "شخص/شرکت",
  customerAddress: "آدرس",
  customerTelephone: "تلفن",
  cutomerBusinessNameActive: true,
  customerAddressActive: false,
  customerTelephoneActive: false,
  businessNameActive: true,
  addressActive: false,
  telephoneActive: false,
  tableStyle: "fill",
  activeSumTax: false,
  activeSumDiscount: false,
  activeSumQuantity: false,
  customerMobile: true,
  mobile: false,
  invoiceDetails: [
    {
      title: shortid.generate(),
      columns: [
        {
          title: shortid.generate(),
          value: "logo",
          order: 1,
        },
        {
          title: shortid.generate(),
          value: "",
          order: 2,
        },
        {
          title: shortid.generate(),
          value: "invoiceInfo",
          order: 3,
        },
      ],
    },
    {
      title: shortid.generate(),
      columns: [
        {
          title: shortid.generate(),
          value: "customerInfo",
          order: 1,
        },
        {
          title: shortid.generate(),
          value: "sellerInfo",
          order: 2,
        },
      ],
    },
  ],
};
const initialState = {
  factor: null,
  factors: [],
  filteredFactors: [],
  factorPattern: invoiceInitialValues,
};

const factorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FACTOR:
      return {
        ...state,
        factor: action.factor,
      };
    case RESET_FACTOR:
      return {
        ...state,
        factor: null,
      };
    case SET_FACTORS:
      return {
        ...state,
        factors: action.filtered ? state.factors : action.factors,
        filteredFactors: action.filtered ? action.factors : state.filteredFactors,
      };
    case SET_FACTOR_PATTERN:
      return {
        ...state,
        factorPattern: action?.factorPattern,
      };
    default:
      return state;
  }
};

export default factorReducer;
